export var ETheme;
(function (ETheme) {
    ETheme["DARK"] = "dark";
    ETheme["LIGHT"] = "light";
})(ETheme || (ETheme = {}));
const FNX_SESSION_THEME = 'fnx-session-theme';
export function setTheme(theme) {
    document.documentElement.setAttribute('theme', theme);
    window.localStorage.setItem(FNX_SESSION_THEME, theme);
}
export function getTheme() {
    return (document.documentElement.getAttribute('theme') ||
        window.localStorage.getItem(FNX_SESSION_THEME) ||
        ETheme.DARK);
}
